import { NavItem } from "../types";

export function NavLinkSection({ navLinks }: { navLinks: NavItem[] }) {
    return (
        <nav className="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3">
            {navLinks.map((n, i) => (
                <a
                    key={i}
                    href={n.url}
                    className={'bg-brand-gray text-black rounded-2xl shadow-sm px-3 py-[19px] w-full flex items-center justify-center hover:shadow-none transition-shadow no-underline hover:bg-brand-detail-gray-light'}
                >
                    {n.title}
                </a>
            ))}
        </nav>
    );
}